import { io } from "socket.io-client"

const socket = io(import.meta.env.VITE_SOCKET_URL) // Geliştirme ortamı için

export default function (app) {
  // Global properties'e ekle (Options API için)
  app.config.globalProperties.$socket = socket
    
  // Provide/Inject için (Composition API için)
  app.provide('socket', socket)
}
